<div class="player-container">
  <!-- Overlay para cerrar el sidebar -->
  @if (sidebarOpen()) {
  <div class="sidebar-overlay" (click)="closeSidebar()"></div>
  }

  <!-- Left Sidebar - Course Content -->
  <aside class="content-sidebar" [class.open]="sidebarOpen()">
    <button class="back-btn" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <span>Volver al inicio</span>
    </button>

    <div class="course-progress-card">
      <h3 class="course-title-sidebar">{{ course.title }}</h3>
      <div class="progress-info">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="course.progress"></div>
        </div>
        <p class="progress-text">{{ course.completedLessons }}/{{ course.totalLessons }} lecciones • {{ course.progress
          }}%</p>
      </div>
    </div>

    <!-- Lessons List -->
    <nav class="lessons-nav">
      @for (section of courseSections; track section.id) {
      <div class="section-container">
        <button class="section-btn" (click)="toggleSection(section.id)">
          <svg class="chevron-icon" [class.expanded]="section.expanded" width="18" height="18" viewBox="0 0 18 18"
            fill="none">
            <path d="M6 4L10 9L6 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span>{{ section.title }}</span>
        </button>

        @if (section.expanded) {
        <ul class="lesson-list">
          @for (lesson of section.lessons; track lesson.id) {
          <li class="lesson-list-item" [class.active]="lesson.id === currentLessonData().id"
            [class.completed]="lesson.completed" (click)="selectLesson(lesson)">
            <div class="lesson-icon">
              @if (lesson.completed) {
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="8" fill="#77d27a" />
                <path d="M5 9L8 12L13 6" stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
              } @else {
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5" />
                <path d="M7 6L12 9L7 12V6Z" fill="currentColor" />
              </svg>
              }
            </div>
            <div class="lesson-info-item">
              <span class="lesson-title-item">{{ lesson.title }}</span>
              <span class="lesson-duration">{{ lesson.duration }}</span>
            </div>
          </li>
          }
        </ul>

        <!-- Examen del módulo (si existe) -->
        @if (section.examen) {
        <div class="exam-section">
          <button class="btn-exam" (click)="goToExam(section.examen.id)">
            <div class="exam-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M5 2H15C16.1046 2 17 2.89543 17 4V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V4C3 2.89543 3.89543 2 5 2Z"
                  stroke="currentColor" stroke-width="1.5" />
                <path d="M7 6H13M7 10H13M7 14H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div class="exam-info">
              <span class="exam-title">{{ section.examen.titulo }}</span>
              <div class="exam-meta">
                <span class="exam-questions">{{ section.examen.num_preguntas }} preguntas</span>
                <span class="exam-time">{{ section.examen.tiempo_limite }} min</span>
              </div>
            </div>
            <svg class="exam-arrow" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M6 4L12 9L6 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        }
        }
      </div>
      }
    </nav>
  </aside>

  <!-- Main Content Area -->
  <main class="player-main">
    <!-- Mobile Top Bar -->
    <div class="mobile-top-bar">
      <button class="mobile-menu-btn" (click)="toggleSidebar()" [class.active]="sidebarOpen()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="2" y="4" width="16" height="2" rx="1" fill="currentColor" />
          <rect x="2" y="9" width="16" height="2" rx="1" fill="currentColor" />
          <rect x="2" y="14" width="16" height="2" rx="1" fill="currentColor" />
        </svg>
        <span>Contenido</span>
      </button>

      <button class="mobile-back-btn" (click)="goBack()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <span>Volver</span>
      </button>
    </div>

    <!-- Video Player / Blog Content -->
    <div class="video-wrapper">
      @if (currentLessonData().tipo_contenido === 'recursos') {
      <!-- Recursos Interface -->
      <div class="recursos-interface">
        <!-- Header -->
        <div class="recursos-header">
          <div class="recursos-header-content">
            <div class="recursos-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 4L28 10L16 16L4 10L16 4Z" fill="currentColor" opacity="0.2" />
                <path d="M4 16L16 22L28 16M4 22L16 28L28 22" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="recursos-header-text">
              <h1 class="recursos-title">{{ currentLessonData().title }}</h1>
              <p class="recursos-subtitle">Material de apoyo y recursos para esta lección</p>
            </div>
            <button class="btn-complete-recursos" [class.completed]="isLessonCompleted()" (click)="markAsCompleted()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                @if (isLessonCompleted()) {
                <circle cx="10" cy="10" r="9" fill="#77d27a" />
                <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                } @else {
                <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5" />
                <path d="M6 10L9 13L14 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                }
              </svg>
              <span>{{ isLessonCompleted() ? 'Completado' : 'Marcar como completado' }}</span>
            </button>
          </div>
        </div>

        <!-- Descripción si existe -->
        @if (safeDescriptionContent) {
        <div class="recursos-description">
          <div [innerHTML]="safeDescriptionContent"></div>
        </div>
        }

        <!-- Recursos Oficiales del Curso -->
        <div class="recursos-section">
          <div class="section-header">
            <h2 class="section-title">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7 1L9 5L13 5.5L10 8.5L10.5 12.5L7 10.5L3.5 12.5L4 8.5L1 5.5L5 5L7 1Z" fill="#FFB800"
                  stroke="#FFB800" />
              </svg>
              Material del Curso
            </h2>
            @if (resources.length > 0) {
            <span class="course-badge">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1L9 5L13 5.5L10 8.5L10.5 12.5L7 10.5L3.5 12.5L4 8.5L1 5.5L5 5L7 1Z" fill="#FFB800"
                  stroke="#FFB800" />
              </svg>
              {{ resources.length }} recurso{{ resources.length !== 1 ? 's' : '' }}
            </span>
            }
          </div>

          @if (resources.length > 0) {
          <div class="recursos-grid">
            @for (resource of resources; track resource.id) {
            <div class="resource-card">
              <div class="resource-card-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <rect width="40" height="40" rx="8" fill="rgba(14, 64, 216, 0.1)" />
                  <path
                    d="M20 12H14C13.4696 12 12.9609 12.2107 12.5858 12.5858C12.2107 12.9609 12 13.4696 12 14V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V20M20 12L28 20M20 12V20H28"
                    stroke="#0e40d8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="resource-card-content">
                <h3 class="resource-card-name">{{ resource.name }}</h3>
                <p class="resource-card-meta">
                  <span class="resource-type">{{ resource.type }}</span>
                  <span class="resource-separator">•</span>
                  <span class="resource-size">{{ resource.size }}</span>
                </p>
              </div>
              <button class="resource-card-download" (click)="downloadResource(resource)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M17 13V17H3V13M10 14V3M10 14L6 10M10 14L14 10" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="32" fill="rgba(255, 255, 255, 0.05)" />
              <path d="M32 20V32M32 38H32.02" stroke="rgba(255, 255, 255, 0.3)" stroke-width="3"
                stroke-linecap="round" />
            </svg>
            <p>No hay recursos disponibles para esta lección</p>
          </div>
          }
        </div>

        <!-- Sección para subir recursos (SIEMPRE VISIBLE) -->
        <div class="upload-section-always">
          <div class="upload-header">
            <h3 class="upload-title">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 3V17M3 10H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
              Comparte tus recursos
            </h3>
            <p class="upload-description">Sube tus propios archivos relacionados con esta lección</p>
          </div>

          @if (!showUploadForm()) {
          <button class="btn-upload-primary" (click)="abrirFormularioSubida()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M3 13V17H17V13M10 14V3M10 3L6 7M10 3L14 7" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Subir Recurso</span>
          </button>
          } @else {
          <div class="upload-form">
            <div class="form-group">
              <label class="form-label">Archivo *</label>
              <div class="file-input-wrapper">
                <input type="file" id="fileInput" class="file-input" (change)="onFileSelected($event)"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.jpg,.jpeg,.png,.gif">
                <label for="fileInput" class="file-input-label">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3 13V17H17V13M10 14V3M10 3L6 7M10 3L14 7" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Seleccionar archivo</span>
                </label>
              </div>
              @if (uploadForm.selectedFile()) {
              <div class="selected-file">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 1L15 8L8 15L1 8L8 1Z" fill="#0e40d8" stroke="#0e40d8" />
                  <path d="M5 8L7 10L11 6" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>
                <span class="file-name">{{ getSelectedFileName() }}</span>
                <span class="file-size">{{ getSelectedFileSize() }}</span>
              </div>
              }
            </div>

            <div class="form-group">
              <label class="form-label">Nombre del recurso *</label>
              <input type="text" class="form-input" placeholder="Ej: Ejercicios resueltos"
                [(ngModel)]="uploadForm.nombre_recurso" [disabled]="isUploadingResource()">
            </div>

            <div class="form-group">
              <label class="form-label">Descripción (opcional)</label>
              <textarea class="form-textarea" rows="3" placeholder="Describe brevemente el contenido del recurso..."
                [(ngModel)]="uploadForm.descripcion" [disabled]="isUploadingResource()">
                  </textarea>
            </div>

            <div class="form-actions">
              <button class="btn-form btn-cancel" (click)="cerrarFormularioSubida()" [disabled]="isUploadingResource()">
                Cancelar
              </button>
              <button class="btn-form btn-submit" (click)="subirRecursoEstudiante()" [disabled]="isUploadingResource()">
                @if (isUploadingResource()) {
                <span class="spinner-small"></span>
                <span>Subiendo...</span>
                } @else {
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 11V15H15V11M9 12V3M9 3L6 6M9 3L12 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Subir Recurso</span>
                }
              </button>
            </div>
          </div>
          }
        </div>

        <!-- Recursos Subidos por el Estudiante -->
        <div class="uploaded-resources-section">
          <div class="section-header">
            <h3 class="section-title">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5" />
                <path d="M6 10L8 12L14 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              Tus Recursos
            </h3>
            @if (recursosEstudiante().length > 0) {
            <span class="student-badge">{{ recursosEstudiante().length }} subido{{ recursosEstudiante().length !== 1 ?
              's' : '' }}</span>
            }
          </div>

          @if (isLoadingRecursos()) {
          <div class="loading-resources">
            <div class="spinner-small"></div>
            <p>Cargando recursos...</p>
          </div>
          } @else if (recursosEstudiante().length > 0) {
          <div class="recursos-grid">
            @for (recurso of recursosEstudiante(); track recurso.id_recurso) {
            <div class="resource-card uploaded">
              <div class="resource-card-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <rect width="40" height="40" rx="8" fill="rgba(14, 216, 100, 0.1)" />
                  <path
                    d="M20 12H14C13.4696 12 12.9609 12.2107 12.5858 12.5858C12.2107 12.9609 12 13.4696 12 14V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V20M20 12L28 20M20 12V20H28"
                    stroke="#0ed864" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="upload-badge-icon">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="6" cy="6" r="6" fill="#0ed864" />
                    <path d="M4 6L5 7L8 4" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </span>
              </div>
              <div class="resource-card-content">
                <h3 class="resource-card-name">{{ recurso.nombre_recurso }}</h3>
                <p class="resource-card-meta">
                  <span class="resource-type">{{ recurso.tipo_recurso }}</span>
                  <span class="resource-separator">•</span>
                  <span class="resource-size">{{ getRecursoSize(recurso) }}</span>
                </p>
                @if (recurso.descripcion) {
                <p class="resource-card-description">{{ recurso.descripcion }}</p>
                }
                <p class="resource-card-date">Subido el {{ recurso.fecha_subida | date:'dd/MM/yyyy' }}</p>
              </div>
              <button class="resource-card-download" (click)="downloadResource(getResourceFromRecurso(recurso))">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M17 13V17H3V13M10 14V3M10 14L6 10M10 14L14 10" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state-small">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="24" fill="rgba(255, 255, 255, 0.03)" />
              <path d="M24 16V24M24 28H24.01" stroke="rgba(255, 255, 255, 0.2)" stroke-width="2"
                stroke-linecap="round" />
            </svg>
            <p>No has subido recursos aún</p>
          </div>
          }
        </div>
      </div>
      } @else if (currentLessonData().tipo_contenido === 'podcast' && safeAudioUrl) {
      <!-- Podcast Player Interface -->
      <div class="podcast-interface">
        <div class="podcast-container">
          <div class="podcast-cover-art">
            <div class="podcast-icon-large">
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                <line x1="12" y1="19" x2="12" y2="23"></line>
                <line x1="8" y1="23" x2="16" y2="23"></line>
              </svg>
            </div>
          </div>

          <!-- Custom Player Card -->
          <div class="podcast-player-card">
            <div class="podcast-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                <line x1="12" y1="19" x2="12" y2="23"></line>
                <line x1="8" y1="23" x2="16" y2="23"></line>
              </svg>
              PODCAST
            </div>

            <h2 class="podcast-title-player">{{ currentLessonData().title }}</h2>
            <p class="podcast-instructor">{{ course.instructor }}</p>

            <div class="audio-progress-container">
              <span class="time-text">{{ formatTime(audioCurrentTime()) }}</span>
              <input type="range" min="0" [max]="audioDuration()" [value]="audioCurrentTime()"
                (input)="seekAudio($event)" class="audio-slider">
              <span class="time-text">{{ formatTime(audioDuration()) }}</span>
            </div>

            <div class="audio-controls">
              <div class="volume-control">
                <button class="btn-icon-small" (click)="toggleMute()">
                  @if (isMuted() || audioVolume() === 0) {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <line x1="23" y1="9" x2="17" y2="15"></line>
                    <line x1="17" y1="9" x2="23" y2="15"></line>
                  </svg>
                  } @else {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                  </svg>
                  }
                </button>
                <input type="range" min="0" max="1" step="0.1" [value]="audioVolume()" (input)="setVolume($event)"
                  class="volume-slider">
              </div>

              <div class="playback-controls">
                <button class="btn-icon" (click)="rewindAudio(10)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="11 19 2 12 11 5 11 19"></polygon>
                    <polygon points="22 19 13 12 22 5 22 19"></polygon>
                  </svg>
                  <span class="seek-label">-10s</span>
                </button>

                <button class="btn-play-pause" (click)="toggleAudioPlay()">
                  @if (isPlaying()) {
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <rect x="6" y="4" width="4" height="16"></rect>
                    <rect x="14" y="4" width="4" height="16"></rect>
                  </svg>
                  } @else {
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                  </svg>
                  }
                </button>

                <button class="btn-icon" (click)="forwardAudio(10)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="13 19 22 12 13 5 13 19"></polygon>
                    <polygon points="2 19 11 12 2 5 2 19"></polygon>
                  </svg>
                  <span class="seek-label">+10s</span>
                </button>
              </div>

              <div class="next-control">
                <button class="btn-icon-small" (click)="goToNextLesson()">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="5 4 15 12 5 20 5 4"></polygon>
                    <line x1="19" y1="5" x2="19" y2="19"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Hidden Audio Element -->
          <audio #audioPlayer [src]="safeAudioUrl" (timeupdate)="onAudioTimeUpdate()"
            (loadedmetadata)="onAudioLoadedMetadata()" (ended)="onAudioEnded()" style="display: none;">
          </audio>
        </div>
      </div>
      } @else if (currentLessonData().tipo_contenido === 'blog' && safeBlogContent) {
      <!-- Blog Article Format -->
      <article class="blog-article">
        <!-- Blog Cover/Banner -->
        <div class="blog-cover" [style.background-image]="getBlogCoverImage()"
          [class.has-image]="currentLessonData().foto_portada">
          <div class="blog-cover-overlay">
            <div class="blog-category">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1L10 5L15 6L11.5 9.5L12.5 14.5L8 12L3.5 14.5L4.5 9.5L1 6L6 5L8 1Z" fill="currentColor" />
              </svg>
              <span>Lectura</span>
            </div>
          </div>
        </div>

        <!-- Blog Header -->
        <header class="blog-header">
          <h1 class="blog-title">{{ currentLessonData().title }}</h1>

          <div class="blog-meta">
            <div class="meta-item">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="6" r="3" stroke="currentColor" stroke-width="1.5" />
                <path d="M2 15C2 12 5 9 9 9C13 9 16 12 16 15" stroke="currentColor" stroke-width="1.5" />
              </svg>
              <span>{{ course.instructor }}</span>
            </div>

            @if (currentLessonData().duration) {
            <div class="meta-item">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.5" />
                <path d="M9 5V9L12 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <span>{{ currentLessonData().duration }} lectura</span>
            </div>
            }

            <div class="meta-item">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 4H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M3 9H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M3 14H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <span>Nivel principiante</span>
            </div>
          </div>

          <!-- Share Buttons -->
          <div class="blog-share">
            <span class="share-label">Compartir:</span>
            <button class="share-btn" title="Compartir en Twitter">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M15 5C14.5 7.5 12.5 12 9 13C5.5 14 2 12.5 2 12.5C2 12.5 4 12 5 11C5 11 1.5 9 3 5C3 5 5.5 8 10 8V6.5C10 5 11.5 4 13 4.5C14 4.8 14.5 5 15 5Z"
                  fill="currentColor" />
              </svg>
            </button>
            <button class="share-btn" title="Compartir en Facebook">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 11.9917 5.18367 14.4526 8.0625 14.9062V11.0312H6.5625V9H8.0625V7.35938C8.0625 5.88203 9.08203 4.96875 10.4297 4.96875C11.0703 4.96875 11.7422 5.08594 11.7422 5.08594V6.5625H11.0039C10.2773 6.5625 10.0312 7.01172 10.0312 7.47266V9H11.6758L11.3906 11.0312H10.0312V14.9062C12.9163 14.4526 15 11.9917 15 9Z"
                  fill="currentColor" />
              </svg>
            </button>
            <button class="share-btn" title="Compartir enlace">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M10 7L7 10M7 10L10 13M7 10H14C15.1046 10 16 9.10457 16 8V4C16 2.89543 15.1046 2 14 2H4C2.89543 2 2 2.89543 2 4V8C2 9.10457 2.89543 10 4 10H7Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </button>
          </div>
        </header>

        <!-- Blog Content -->
        <div class="blog-body">
          <div class="blog-content-wrapper" [innerHTML]="safeBlogContent"></div>
        </div>

        <!-- Blog Footer -->
        <footer class="blog-footer">
          <button class="btn-next-lesson" (click)="goToNextLesson()">
            <span>Siguiente lección</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7 5L13 10L7 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </footer>
      </article>
      } @else if (videoBlocked()) {
      <!-- Video bloqueado por límite de sesiones -->
      <div class="video-blocked-overlay">
        <div class="blocked-content">
          <div class="blocked-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
              <path d="M4.93 4.93L19.07 19.07" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </div>
          <h2 class="blocked-title">Límite de Reproducción Alcanzado</h2>
          <p class="blocked-message">
            Ya tienes <strong>{{sesionesActivas()}}/{{maxSesiones()}}</strong> sesión(es) de reproducción activa(s).
          </p>
          <p class="blocked-description">
            Solo puedes reproducir contenido en máximo <strong>{{maxSesiones()}}</strong> dispositivos al mismo tiempo.
            Por favor, cierra otras sesiones activas para continuar.
          </p>
          <div class="blocked-actions">
            <button class="btn-reload" (click)="getCurrentLesson() && selectLesson(getCurrentLesson()!)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M20.49 9C19.9828 7.56678 19.1209 6.28542 17.9845 5.27542C16.8482 4.26541 15.4745 3.55976 13.9917 3.22426C12.5089 2.88875 10.9652 2.93434 9.50481 3.35677C8.04437 3.77921 6.71475 4.56471 5.64 5.64L1 10M23 14L18.36 18.36C17.2853 19.4353 15.9556 20.2208 14.4952 20.6432C13.0348 21.0657 11.4911 21.1112 10.0083 20.7757C8.52547 20.4402 7.1518 19.7346 6.01547 18.7246C4.87913 17.7146 4.01717 16.4332 3.51 15"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Reintentar
            </button>
          </div>
          <div class="blocked-help">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
              <path d="M12 16V12M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>Si crees que esto es un error, intenta cerrar sesión y volver a iniciar.</span>
          </div>
        </div>
      </div>
      } @else if (verificandoSesiones()) {
      <!-- Verificando sesiones -->
      <div class="loading-placeholder">
        <div class="spinner-large"></div>
        <p>Verificando sesiones activas...</p>
      </div>
      } @else if (isVideoHls() && videoHlsUrl) {
      <!-- Video HLS (.m3u8) -->
      <video #hlsVideoPlayer class="video-player-hls" controls playsinline preload="metadata" crossorigin="anonymous">
        Tu navegador no soporta la reproducción de video HLS.
      </video>
      } @else if (isVideoMp4() && videoMp4Url) {
      <!-- Video MP4 -->
      <video class="video-player-mp4" [src]="videoMp4Url" controls playsinline preload="metadata">
        Tu navegador no soporta la reproducción de video.
      </video>
      } @else if (isVideoYoutube() && youtubeEmbedUrl()) {
      <!-- YouTube: iframe responsive, controles nativos ocultos -->
      <div #youtubePlayerShell class="youtube-player-shell">
        <div class="youtube-player-container">
          <iframe #youtubeIframe class="youtube-embed-iframe" width="1280" height="720"
            [src]="youtubeEmbedUrl()!" title="Video de la lección"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            referrerpolicy="strict-origin-when-cross-origin"></iframe>
          <div class="youtube-click-shield" aria-hidden="true"></div>
          <div class="youtube-branding-mask youtube-branding-mask--top" aria-hidden="true"></div>
          <div class="youtube-branding-mask youtube-branding-mask--br" aria-hidden="true"></div>
          <div class="youtube-branding-mask youtube-branding-mask--tr" aria-hidden="true"></div>
          @if (!youtubePlaying()) {
          <div class="youtube-paused-veil" aria-hidden="true"></div>
          }
        </div>
        <div class="video-player-controls">
          <button type="button" class="video-control-btn video-control-btn--seek" (click)="seekYoutubeBackward()"
            aria-label="Retroceder 10 segundos" title="Retroceder 10 s">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
            </svg>
            <span class="video-seek-label">10</span>
          </button>
          <button type="button" class="video-control-btn" (click)="toggleYoutubePlayback()"
            [attr.aria-label]="youtubePlaying() ? 'Pausar video' : 'Reproducir video'" title="Reproducir / Pausar">
            @if (youtubePlaying()) {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <rect x="6" y="5" width="4" height="14" rx="1" />
              <rect x="14" y="5" width="4" height="14" rx="1" />
            </svg>
            } @else {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M8 5v14l11-7z" />
            </svg>
            }
          </button>
          <button type="button" class="video-control-btn video-control-btn--seek" (click)="seekYoutubeForward()"
            aria-label="Adelantar 10 segundos" title="Adelantar 10 s">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z" />
            </svg>
            <span class="video-seek-label">10</span>
          </button>
          <button type="button" class="video-control-btn" (click)="toggleYoutubeFullscreen()"
            [attr.aria-label]="youtubeFullscreen() ? 'Salir de pantalla completa' : 'Pantalla completa'"
            title="Pantalla completa">
            @if (youtubeFullscreen()) {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M8 3v3H5v2h5V3H8zm11 0h-3v5h2V5h3V3h-2zM8 18H5v-3H3v5h5v-2zm11 3h-5v-2h3v-3h2v5z" />
            </svg>
            } @else {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M3 5h5V3H3v2zm13-2v2h5V3h-5zM3 19h5v-2H3v2zm13 2h5v-2h-5v2zM5 7H3v10h2V7zm16 0h-2v10h2V7z" />
            </svg>
            }
          </button>
        </div>
      </div>
      } @else if (safeVideoUrl) {
      <!-- Video HTML (iframe / VdoCipher) -->
      <div #embedPlayerContainer class="embed-player-shell">
        <div class="embed-player-content" [innerHTML]="safeVideoUrl"></div>
        <div class="video-player-controls">
          <button type="button" class="video-control-btn" (click)="toggleEmbedFullscreen()"
            [attr.aria-label]="youtubeFullscreen() ? 'Salir de pantalla completa' : 'Pantalla completa'"
            title="Pantalla completa">
            @if (youtubeFullscreen()) {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M8 3v3H5v2h5V3H8zm11 0h-3v5h2V5h3V3h-2zM8 18H5v-3H3v5h5v-2zm11 3h-5v-2h3v-3h2v5z" />
            </svg>
            } @else {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M3 5h5V3H3v2zm13-2v2h5V3h-5zM3 19h5v-2H3v2zm13 2h5v-2h-5v2zM5 7H3v10h2V7zm16 0h-2v10h2V7z" />
            </svg>
            }
          </button>
        </div>
      </div>
      } @else {
      <div class="loading-placeholder">
        <div class="spinner-large"></div>
        <p>Cargando...</p>
      </div>
      }
    </div>

    <!-- Video Info & Controls (oculto para tipo recursos) -->
    @if (currentLessonData().tipo_contenido !== 'recursos') {
    <div class="video-controls">
      <div class="video-header">
        <div class="video-info-header">
          <h1 class="video-title">{{ currentLessonData().title }}</h1>
          <p class="instructor-name">{{ course.instructor }}</p>
        </div>
        <button class="btn-complete" [class.completed]="isLessonCompleted()" (click)="markAsCompleted()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            @if (isLessonCompleted()) {
            <circle cx="10" cy="10" r="9" fill="#77d27a" />
            <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" />
            } @else {
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5" />
            <path d="M6 10L9 13L14 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            }
          </svg>
          <span>{{ isLessonCompleted() ? 'Completado' : 'Marcar como completado' }}</span>
        </button>
      </div>
    </div>
    }

    <!-- Tabs (oculto para tipo recursos) -->
    @if (currentLessonData().tipo_contenido !== 'recursos') {
    <div class="content-tabs">
      <button class="tab-btn" [class.active]="currentTab() === 'overview'" (click)="setTab('overview')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="3" y="4" width="14" height="3" rx="1" fill="currentColor" />
          <rect x="3" y="9" width="14" height="3" rx="1" fill="currentColor" />
          <rect x="3" y="14" width="9" height="3" rx="1" fill="currentColor" />
        </svg>
        <span>Descripción</span>
      </button>

      <button class="tab-btn" [class.active]="currentTab() === 'resources'" (click)="setTab('resources')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M13 2L16 5M2 18L5 18L16 7L13 4L2 15V18Z" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Recursos ({{ resources.length }})</span>
      </button>

      <button class="tab-btn" [class.active]="currentTab() === 'notes'" (click)="setTab('notes')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M9 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V16C2 16.5304 2.21071 17.0391 2.58579 17.4142C2.96086 17.7893 3.46957 18 4 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V11"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M16 1L18 3L10 11H8V9L16 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>Mis Notas</span>
      </button>

      <button class="tab-btn" [class.active]="currentTab() === 'comments'" (click)="setTab('comments')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M18 9C18 13.4183 14.4183 17 10 17L4 20V17C2.34315 17 1 15.6569 1 14V5C1 3.34315 2.34315 2 4 2H15C16.6569 2 18 3.34315 18 5V9Z"
            stroke="currentColor" stroke-width="1.5" />
        </svg>
        <span>Comentarios</span>
      </button>

      <button class="tab-btn btn-assistant-tab" [class.active]="currentTab() === 'assistant'"
        (click)="setTab('assistant')">
        <div class="assistant-tab-glow"></div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="11" r="2" fill="currentColor" />
        </svg>
        <span>Asistente AI</span>
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <!-- Overview Tab -->
      @if (currentTab() === 'overview') {
      <div class="overview-content">
        <h2 class="content-title">Acerca de esta lección</h2>
        @if (safeDescriptionContent) {
        <div class="description-text" [innerHTML]="safeDescriptionContent"></div>
        } @else {
        <p class="description-text">Sin descripción disponible</p>
        }
      </div>
      }

      <!-- Resources Tab -->
      @if (currentTab() === 'resources') {
      <div class="resources-content">
        <!-- Recursos Oficiales del Curso -->
        <div class="section-header">
          <h2 class="content-title">Material del Curso</h2>
          @if (resources.length > 0) {
          <span class="course-badge">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 1L9 5L13 5.5L10 8.5L10.5 12.5L7 10.5L3.5 12.5L4 8.5L1 5.5L5 5L7 1Z" fill="#FFB800"
                stroke="#FFB800" />
            </svg>
            Oficial
          </span>
          }
        </div>
        @if (resources.length > 0) {
        <div class="resources-list">
          @for (resource of resources; track resource.id) {
          <div class="resource-item">
            <div class="resource-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
                  stroke="currentColor" stroke-width="2" />
                <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" />
              </svg>
            </div>
            <div class="resource-info">
              <h3 class="resource-name">{{ resource.name }}</h3>
              <p class="resource-meta">{{ resource.type }} • {{ resource.size }}</p>
            </div>
            <button class="btn-download" (click)="downloadResource(resource)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M17 13V17H3V13M10 14V3M10 14L6 10M10 14L14 10" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Descargar</span>
            </button>
          </div>
          }
        </div>
        } @else {
        <div class="empty-state">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="rgba(255, 255, 255, 0.05)" />
            <path d="M32 20V32M32 38H32.02" stroke="rgba(255, 255, 255, 0.3)" stroke-width="3" stroke-linecap="round" />
          </svg>
          <p>No hay recursos disponibles para esta lección</p>
        </div>
        }

        <!-- Sección para subir recursos (solo si hay recursos disponibles) -->
        @if (resources.length > 0) {
        <div class="upload-section">
          <div class="upload-header">
            <h3 class="upload-title">Comparte tus recursos</h3>
            <p class="upload-description">Sube tus propios archivos relacionados con esta lección</p>
          </div>

          @if (!showUploadForm()) {
          <button class="btn-upload" (click)="abrirFormularioSubida()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 3V17M3 10H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>Subir Recurso</span>
          </button>
          } @else {
          <div class="upload-form">
            <div class="form-group">
              <label class="form-label">Archivo *</label>
              <div class="file-input-wrapper">
                <input type="file" id="fileInput" class="file-input" (change)="onFileSelected($event)"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.jpg,.jpeg,.png,.gif">
                <label for="fileInput" class="file-input-label">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3 13V17H17V13M10 14V3M10 3L6 7M10 3L14 7" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Seleccionar archivo</span>
                </label>
              </div>
              @if (uploadForm.selectedFile()) {
              <div class="selected-file">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 1L15 8L8 15L1 8L8 1Z" fill="#0e40d8" stroke="#0e40d8" />
                  <path d="M5 8L7 10L11 6" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>
                <span class="file-name">{{ getSelectedFileName() }}</span>
                <span class="file-size">{{ getSelectedFileSize() }}</span>
              </div>
              }
            </div>

            <div class="form-group">
              <label class="form-label">Nombre del recurso *</label>
              <input type="text" class="form-input" placeholder="Ej: Ejercicios resueltos"
                [(ngModel)]="uploadForm.nombre_recurso" [disabled]="isUploadingResource()">
            </div>

            <div class="form-group">
              <label class="form-label">Descripción (opcional)</label>
              <textarea class="form-textarea" rows="3" placeholder="Describe brevemente el contenido del recurso..."
                [(ngModel)]="uploadForm.descripcion" [disabled]="isUploadingResource()">
                    </textarea>
            </div>

            <div class="form-actions">
              <button class="btn-form btn-cancel" (click)="cerrarFormularioSubida()" [disabled]="isUploadingResource()">
                Cancelar
              </button>
              <button class="btn-form btn-submit" (click)="subirRecursoEstudiante()" [disabled]="isUploadingResource()">
                @if (isUploadingResource()) {
                <span class="spinner-small"></span>
                <span>Subiendo...</span>
                } @else {
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 11V15H15V11M9 12V3M9 3L6 6M9 3L12 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Subir Recurso</span>
                }
              </button>
            </div>
          </div>
          }
        </div>
        }

        <!-- Sección de Recursos Subidos por el Estudiante -->
        @if (resources.length > 0) {
        <div class="uploaded-resources-section">
          <div class="section-header">
            <h3 class="section-title">Tus Recursos</h3>
            <div class="header-badges">
              <span class="student-badge">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <circle cx="7" cy="7" r="6" stroke="#0e40d8" stroke-width="1.5" />
                  <path d="M4 7L6 9L10 5" stroke="#0e40d8" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                Subidos por ti
              </span>
              @if (recursosEstudiante().length > 0) {
              <span class="resources-count">{{ recursosEstudiante().length }}</span>
              }
            </div>
          </div>

          @if (isLoadingRecursos()) {
          <div class="loading-resources">
            <div class="spinner-small"></div>
            <p>Cargando recursos...</p>
          </div>
          } @else if (recursosEstudiante().length > 0) {
          <div class="resources-list">
            @for (recurso of recursosEstudiante(); track recurso.id_recurso) {
            <div class="resource-item uploaded">
              <div class="resource-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
                    stroke="currentColor" stroke-width="2" />
                  <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" />
                </svg>
                <span class="upload-badge">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 1L11 6L6 11L1 6L6 1Z" fill="#0e40d8" />
                    <path d="M4 6L5 7L8 4" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </span>
              </div>
              <div class="resource-info">
                <h3 class="resource-name">{{ recurso.nombre_recurso }}</h3>
                <p class="resource-meta">
                  {{ recurso.tipo_recurso }} • {{ getRecursoSize(recurso) }}
                </p>
                @if (recurso.descripcion) {
                <p class="resource-description">{{ recurso.descripcion }}</p>
                }
                <p class="resource-date">Subido el {{ recurso.fecha_subida | date:'dd/MM/yyyy' }}</p>
              </div>
              <button class="btn-download" (click)="downloadResource(getResourceFromRecurso(recurso))">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M17 13V17H3V13M10 14V3M10 14L6 10M10 14L14 10" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Descargar</span>
              </button>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state-small">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="24" fill="rgba(255, 255, 255, 0.03)" />
              <path d="M24 16V24M24 28H24.01" stroke="rgba(255, 255, 255, 0.2)" stroke-width="2"
                stroke-linecap="round" />
            </svg>
            <p>No has subido recursos aún</p>
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- Notes Tab -->
      @if (currentTab() === 'notes') {
      <div class="notes-content">
        <div class="coming-soon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" stroke="rgba(14, 64, 216, 0.3)" stroke-width="4" />
            <path d="M40 25V40L50 45" stroke="rgba(14, 64, 216, 0.6)" stroke-width="4" stroke-linecap="round" />
            <circle cx="40" cy="40" r="3" fill="rgba(14, 64, 216, 0.8)" />
          </svg>
          <h3 class="coming-soon-title">Próximamente</h3>
          <p class="coming-soon-text">La funcionalidad de notas estará disponible pronto. Podrás tomar apuntes mientras
            estudias y acceder a ellos en cualquier momento.</p>
        </div>
      </div>
      }

      <!-- Comments Tab -->
      @if (currentTab() === 'comments') {
      <div class="comments-content">
        <div class="coming-soon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" stroke="rgba(14, 64, 216, 0.3)" stroke-width="4" />
            <path
              d="M60 35C60 48.5 48.5 60 35 60L22 68V60C17.5 60 14 56.5 14 52V28C14 23.5 17.5 20 22 20H52C56.5 20 60 23.5 60 28V35Z"
              stroke="rgba(14, 64, 216, 0.6)" stroke-width="3" />
            <circle cx="30" cy="38" r="3" fill="rgba(14, 64, 216, 0.8)" />
            <circle cx="40" cy="38" r="3" fill="rgba(14, 64, 216, 0.8)" />
            <circle cx="50" cy="38" r="3" fill="rgba(14, 64, 216, 0.8)" />
          </svg>
          <h3 class="coming-soon-title">Próximamente</h3>
          <p class="coming-soon-text">El sistema de comentarios estará disponible pronto. Podrás interactuar con otros
            estudiantes y compartir tus dudas y experiencias.</p>
        </div>
      </div>
      }

      <!-- Assistant Tab -->
      @if (currentTab() === 'assistant') {
      <div class="assistant-content">
        <div class="assistant-chat-container">
          <div class="assistant-chat-header">
            <div class="assistant-info">
              <div class="assistant-avatar-small">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div>
                <h3 class="assistant-chat-title">Tu Tutor Personal</h3>
                <p class="assistant-chat-status">En línea y listo para ayudarte</p>
              </div>
            </div>
            <button class="btn-clear-chat" (click)="clearAssistantChat()" title="Limpiar conversación">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              </svg>
            </button>
          </div>

          <div class="assistant-messages-list" #assistantMessagesContainer>
            @for (message of assistantMessages(); track $index) {
            <div class="chat-bubble-wrapper" [class.user]="message.role === 'user'"
              [class.assistant]="message.role === 'assistant'" [class.new-bubble]="message.isNew">
              <div class="chat-bubble">
                @if (message.role === 'assistant') {
                <div class="bubble-text" [innerHTML]="parseMarkdown(message.content)"></div>
                } @else {
                <p class="bubble-text">{{ message.content }}</p>
                }
                <span class="bubble-time">{{ message.timestamp | date:'HH:mm' }}</span>
              </div>
            </div>
            }

            @if (isAssistantLoading()) {
            <div class="chat-bubble-wrapper assistant">
              <div class="chat-bubble typing">
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
            }

            @if (assistantError()) {
            <div class="assistant-error-box">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <span>{{ assistantError() }}</span>
            </div>
            }
          </div>

          <div class="assistant-input-area">
            <div class="input-container">
              <textarea [(ngModel)]="newAssistantMessage" (keydown)="onAssistantKeyPress($event)"
                placeholder="Haz una pregunta sobre esta lección..." rows="1" [disabled]="isAssistantLoading()"
                class="chat-textarea">
                </textarea>
              <button class="btn-send-assistant" (click)="sendMessageToAssistant()"
                [disabled]="!newAssistantMessage().trim() || isAssistantLoading()">
                @if (isAssistantLoading()) {
                <div class="spinner-tiny"></div>
                } @else {
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
                }
              </button>
            </div>
            <p class="assistant-disclaimer">El Asistente AI puede cometer errores. Verifica la información importante.
            </p>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </main>
</div>